import React from 'react';
import { TopToolbar, useTranslate, Button } from 'react-admin';
import { Link } from 'react-router-dom';
import SettlePayment from './SettlePayment';
import ErrorIcon from '@material-ui/icons/Error';

const FailPaymentButton = ({ record }) => {
	const translate = useTranslate();
	return (
		<Button
			component={Link}
			to={`/paymentFailures/create?paymentId=${record.id}`}
			label={translate('resources.payments.actions.paymentFailed')}
		>
			<ErrorIcon />
		</Button>
	);
};

const PaymentShowActions = ({ basePath, data, resource }) => {
	return (
		<TopToolbar>
			{data && <SettlePayment basePath={basePath} record={data} />}
			{data && <FailPaymentButton basePath={basePath} record={data} />}
		</TopToolbar>
	);
};

export default PaymentShowActions;
